import {cancelOrderUrl, receiveMyOrderUrl, repeatOrderUrl} from 'Utils/urlUtil';
import {T} from 'Actions/translate';

export default (errorMsg, url, method, params, data) => {
    switch (errorMsg) {
        // case 'bad_request':
        // case 'sql_syntax_error':
        // case 'internal_server_error':
        //     if(url === cancelOrderUrl) return '取消订单失败，服务器出现异常';
        //     if(url === receiveMyOrderUrl) return '收货失败，服务器出现异常';
        //     if(url === repeatOrderUrl) return '再次购买失败，服务器出现异常';
        //     break;
        case 'version_error':
        case 'concurrent_data_access_error':
        case 'email_error_retry':
            if (url === cancelOrderUrl)
                return (
                    T('notification_order_cancellation_failed') +
                    ',' +
                    T('notification_refresh_page')
                );
            if (url === receiveMyOrderUrl)
                return (
                    T('notification_goods_failed') +
                    ',' +
                    T('notification_refresh_page')
                );
            break;
        case 'invaild_status':
        case 'invalid_orderStatus':
            if (url === cancelOrderUrl)
                return (
                    T('notification_order_cancellation_failed') +
                    ',' +
                    T('notification_order_not_cancelled') +
                    ',' +
                    T('notification_tel')
                );
            if (url === receiveMyOrderUrl)
                return (
                    T('notification_goods_failed') +
                    ',' +
                    T('notification_no_delivery_order')
                );
            break;
        case 'invalid_orderId':
            if (url === cancelOrderUrl)
                return (
                    T('notification_order_cancellation_failed') +
                    ',' +
                    T('notification_order_not_found') +
                    ',' +
                    T('notification_tel')
                );
            if (url === receiveMyOrderUrl)
                return (
                    T('notification_goods_failed') +
                    ',' +
                    T('notification_order_not_found')
                );
            if (url === repeatOrderUrl)
                return (
                    T('notification_failed_to_buy_again') +
                    ',' +
                    T('notification_order_not_found')
                );
            break;
        case 'order_partially_cancel_not_allowed':
            if (url === cancelOrderUrl)
                return T('notification_order_cannot_be_partially_cancelled');
            break;
        case 'squote_order_not_allowed':
            break;

        case 'dealer_bt_not_allowed':
            if (url === repeatOrderUrl) return T('dealer_customer_info');
            break;

        default:
            if (url === cancelOrderUrl)
                return (
                    T('notification_order_cancellation_failed') +
                    ',' +
                    T('notification_tel')
                );
            if (url === receiveMyOrderUrl)
                return T('notification_goods_failed');
            if (url === repeatOrderUrl)
                return T('notification_failed_to_buy_again');
            break;
    }
};
